import { PageHeader } from '@/components/PageHeader';
import { Card, Button } from '@/components/ui';
import { Check, Shield, Users, Star } from 'lucide-react';

export function PricingPage() {
    const plans = [
        {
            name: "Monthly",
            price: "$1.99",
            period: "/ month",
            features: ["Full Stance & Motion", "Whistle Starts", "Custom Timer", "Cancel Anytime"],
            highlight: false
        },
        {
            name: "Yearly",
            price: "$16.99",
            period: "/ year",
            features: ["Best Value", "Save 30%", "All Features"],
            highlight: true
        },
        {
            name: "Lifetime",
            price: "$49.99",
            period: "",
            features: ["One-time payment", "Forever access", "No subscriptions"],
            highlight: false
        }
    ];

    return (
        <div className="pb-32 animate-fade-in space-y-6">
            <PageHeader title="Member Access" subtitle="Choose your training plan" />

            <div className="px-4 space-y-4">
                {plans.map((plan) => (
                    <Card
                        key={plan.name}
                        className={`p-6 relative overflow-hidden transition-all active:scale-[0.98] ${plan.highlight
                                ? 'bg-gradient-to-br from-gold-500/20 to-orange-500/10 border-gold-500/40 shadow-[0_0_20px_rgba(234,179,8,0.1)]'
                                : 'bg-surface-card border-white/5'
                            }`}
                    >
                        {plan.highlight && (
                            <div className="absolute top-0 right-0 bg-gold-500 text-black text-[10px] font-black px-2 py-1 rounded-bl-xl uppercase tracking-wider">
                                Recommended
                            </div>
                        )}
                        <div className="flex justify-between items-start mb-4">
                            <div>
                                <h3 className={`font-bold text-lg ${plan.highlight ? 'text-gold-400' : 'text-white'}`}>
                                    {plan.name}
                                </h3>
                                <div className="flex items-baseline gap-1 mt-1">
                                    <span className="text-3xl font-black text-white">{plan.price}</span>
                                    <span className="text-xs text-text-muted">{plan.period}</span>
                                </div>
                            </div>
                            {plan.highlight ? <Star className="text-gold-500 fill-gold-500" /> : <Shield className="text-text-muted" />}
                        </div>

                        <ul className="space-y-2 mb-6">
                            {plan.features.map(f => (
                                <li key={f} className="flex items-center gap-2 text-sm text-text-secondary">
                                    <Check className="w-4 h-4 text-green-400" /> {f}
                                </li>
                            ))}
                        </ul>

                        <Button
                            className={`w-full ${plan.highlight ? 'bg-gold-500 hover:bg-gold-400 text-black' : 'bg-white/10 hover:bg-white/20'}`}
                        >
                            Subscribe Now
                        </Button>
                    </Card>
                ))}

                {/* Team Plan */}
                <div className="mt-8 pt-6 border-t border-white/10">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
                            <Users className="w-5 h-5 text-blue-400" />
                        </div>
                        <div>
                            <h3 className="font-bold text-white">Team Subscription</h3>
                            <p className="text-xs text-text-muted">For coaches & programs</p>
                        </div>
                    </div>

                    <Card className="p-4 bg-blue-500/5 border-blue-500/20">
                        <p className="text-sm text-text-secondary mb-4 leading-relaxed">
                            Unlock the full potential of your athletes. Purchase in bulk and issue team codes. Monitor progress via the Team Dashboard.
                        </p>
                        <div className="flex flex-col gap-2">
                            <Button className="w-full bg-blue-600 hover:bg-blue-500">Contact Sales</Button>
                            <p className="text-[10px] text-center text-text-muted">+1 502-639-4989 • info@stancemotion.com</p>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}
